export default {
  // Graytone
  graytone950: '#161616',
  graytone900: '#1f1f1f',
  graytone800: '#454545',
  graytone700: '#4f4f4f',
  graytone600: '#5d5d5d',
  graytone500: '#6d6d6d',
  graytone400: '#888888',
  graytone300: '#b0b0b0',
  graytone200: '#d1d1d1',
  graytone100: '#e7e7e7',
  graytone50: '#f6f6f6',

  // Orange
  orange950: '#430b07',
  orange900: '#7c1c12',
  orange800: '#9b1e11',
  orange700: '#c3240b',
  orange600: '#eb350b',
  orange500: '#fa541c',
  orange400: '#fc743b',
  orange300: '#fea473',
  orange200: '#decaaa',
  orange100: '#dde6d5',
  orange50: '#fff4ed',

  // Blue
  blue950: '#142557',
  blue900: '#193b8f',
  blue800: '#1742b6',
  blue700: '#1451e1',
  blue600: '#1b67f5',
  blue500: '#4190ff',
  blue400: '#59aaff',
  blue300: '#8ec9ff',
  blue200: '#bcddff',
  blue100: '#d9ebff',
  blue50: '#eef7ff',

  // Green
  green950: '#032b1f',
  green900: '#084c36',
  green800: '#085d3f',
  green700: '#06764f',
  green600: '#08935f',
  green500: '#14b575',
  green400: '#39d08f',
  green300: '#71e4ae',
  green200: '#a9f1cb',
  green100: '#d2f9e2',
  green50: '#ecfdf4',

  // Pink
  pink950: '#50024f',
  pink900: '#781777',
  pink800: '#911593',
  pink700: '#b017b4',
  pink600: '#d82ee0',
  pink500: '#e940f5',
  pink400: '#f47fd',
  pink300: '#f8a8ff',
  pink200: '#f9ceff',
  pink100: '#fce7ff',
  pink50: '#fef4ff',

  // Base
  white: '#fff',
  black: '#111',
} as const;
